import { render, staticRenderFns } from "./SendDocumentDetail.vue?vue&type=template&id=fe5f80e8&"
import script from "./SendDocumentDetail.vue?vue&type=script&lang=js&"
export * from "./SendDocumentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe5f80e8')) {
      api.createRecord('fe5f80e8', component.options)
    } else {
      api.reload('fe5f80e8', component.options)
    }
    module.hot.accept("./SendDocumentDetail.vue?vue&type=template&id=fe5f80e8&", function () {
      api.rerender('fe5f80e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/job-request/components/SendDocumentDetail.vue"
export default component.exports